
export const ProgrammeFactSheet = {
    show: function() {
        jQuery('a.delete-fact-sheet').on('click', function() {
            var a = jQuery(this);

            if (confirm(a.attr('data-confirm'))) {
                SmartME.setLoadingIndicator('.main', {overlay: true});
                jQuery.ajax({
                    url: a.attr('href'),
                    type: 'DELETE',
                    success: function() {
                        Turbo.visit(window.location);
                    }
                });
            }
            return false;
        });
    },
    edit: function() {
      jQuery('#programme-fact-sheet-form').find('[type="submit"]').attr('disabled', true);
      import("../components/form_editor/form_editor_api.jsx").then(mod => {
        const FormEditorApi = mod.default;
        console.log(FormEditorApi)
        jQuery('#programme-fact-sheet-form').on('submit', function() {
          jQuery(this).append('<input type="hidden" name="form" />');
          jQuery(this).find('input[name="form"]').val(JSON.stringify(FormEditorApi.getFormJSON()));
        });
        jQuery('#programme-fact-sheet-form').find('[type="submit"]').attr('disabled', false);
      })
  
      jQuery('.form-preview').on('click', ActionJS.ProjectCallPhase.preview_form);
  
    },
    update: function() {
      this.edit();
    }
};